import { useEffect, useState } from "react";
import { BoxIcon, ClocckGreyIcon, DollarGreenIcon, MessageDarkOrangeIcon, MessageGreenIcon, UserGreyIcon, WallClockIcon } from "../../../assets/icons";
import { useNotification } from "../../toster-notification/NotificationContext";
import Loader from "../../shared/Loader";
import { tableService } from "../../../services/tableService";
import { LiveOrderTableInfoDTO } from "../../../models/table/table.response";
import { handleErrorNotification } from "../../../utils/errorNotificatioMessage";
import { tableShapeToIcon } from "../../../models/base/TableShapeType";
import { table } from "console";
import { TableStatusType, tableStatusTypeToColor, tableStatusTypeToString } from "../../../models/base/TableStatusType";
import { OrderStatusType, orderStatusTypeStringToEnum, orderStatusTypeToClassName, orderStatusTypeToString } from "../../../models/base/OrderStatusType";
import { ToLocalDateTimeString } from "../../../utils/dateFormater";
import { orderService } from "../../../services/orderService";
import OrderInfoView1 from "../shared/views/side-views/OrderInfoView1";
import { useParams } from "react-router-dom";

interface TableInfoViewProps {
    selectedTableId?: string;
    onStatusChange?: () => void;
    isCallWaiter?: boolean;
    onWaiterReceive?: (tableId: string) => void;
    refreshTrigger?: number;
}

const TableInfoView: React.FC<TableInfoViewProps> = ({ selectedTableId, onStatusChange, isCallWaiter, onWaiterReceive, refreshTrigger }) => {

    const [tableInfo, setTableInfo] = useState<LiveOrderTableInfoDTO>();

    const [loading, setLoading] = useState<boolean>(false);

    const { notify } = useNotification();
    const localId = useParams().localId;


    useEffect(() => {
        fetchTableInfo();
    }, [selectedTableId, refreshTrigger]);


    const fetchTableInfo = async () => {
        if (!selectedTableId) {
            notify("error", "ID stola nije prosleđen");
            return;
        }

        if (!localId) {
            notify("error", "ID lokala nije prosleđen");
            return;
        }

        setLoading(true);
        try {
            const response = await tableService.getLiveOrderTableInfoById(localId, selectedTableId);

            if (response.success && response.data) {
                setTableInfo(response.data);
            } else {
                notify("error", "Greška pri učitavanju informacija o stolu", response.message || "Došlo je do greške pri učitavanju informacija o stolu.");
            }
        } catch (error) {
            notify("error", "Greška pri učitavanju informacija o stolu", "Došlo je do greške pri učitavanju informacija o stolu.");
            handleErrorNotification(error, notify);
        } finally {
            setLoading(false);
        }
    };

    const handleOrderStatusChange = async (orderId: string, newStatus: OrderStatusType) => {
        if (!localId) {
            notify("error", "ID lokala nije prosleđen");
            return;
        }

        if (!selectedTableId) {
            notify("error", "ID stola nije prosleđen");
            return;
        }

        if (!orderId) {
            notify("error", "ID porudžbine nije prosleđen");
            return;
        }

        setLoading(true);
        try {
            const response = await orderService.changeOrderStatus(localId, orderId, newStatus);

            if (response.success) {
                notify("success", "Uspešno ažuriran status porudžbine.");
                fetchTableInfo();
                onStatusChange?.();
            } else {
                notify("error", "Greška pri ažuriranju statusa porudžbine", response.message || "Došlo je do greške pri ažuriranju statusa porudžbine.");
            }
        } catch (error) {
            notify("error", "Greška pri ažuriranju statusa porudžbine", "Došlo je do greške pri ažuriranju statusa porudžbine.");
            console.error(error);
            handleErrorNotification(error, notify);
        } finally {
            setLoading(false);
        }
    };

    const handleOrderStatusToNext = async (orderId: string) => {
        if (!selectedTableId) {
            notify("error", "ID stola nije prosleđen");
            return;
        }

        if (!localId) {
            notify("error", "ID lokala nije prosleđen");
            return;
        }

        if (!orderId) {
            notify("error", "ID porudžbine nije prosleđen");
            return;
        }

        setLoading(true);
        try {
            const response = await orderService.changeOrderStatusToNext(localId, orderId);
            if (response.success) {
                notify("success", "Uspešno ažuriran status porudžbine.");
                fetchTableInfo();
                onStatusChange?.();
            }
            else {
                notify("error", "Greška pri ažuriranju statusa porudžbine", response.message || "Došlo je do greške pri ažuriranju statusa porudžbine.");
            }
        } catch (error) {
            notify("error", "Greška pri ažuriranju statusa porudžbine", "Došlo je do greške pri ažuriranju statusa porudžbine.");
            handleErrorNotification(error, notify);
        } finally {
            setLoading(false);
        }
    };



    if (tableInfo === undefined && loading === false) {
        return (
            <div className="admin-settings-box-div lo-table-info-block">
                <div className="no-orders-text">Nije izabran nijedan sto.</div>
            </div>
        )
    }

    if (tableInfo === undefined) {
        return (
            <div className="admin-settings-box-div lo-table-info-block">
                <div className="no-orders-text">Nije izabran nijedan sto.</div>
            </div>
        )
    }

    return (
        <div className="admin-settings-box-div lo-table-info-block">

            {loading ? (
                <Loader fullscreen={false} />
            ) : (
                <>
                    <div className="lo-table-info-header">
                        <div className={`lo-table-info-header-image-div ${tableStatusTypeToColor(tableInfo.currentStatus)}`}>
                            <img loading="lazy" src={tableShapeToIcon(tableInfo.shape)} alt="" className="lo-table-info-header-image" />
                        </div>
                        <div className="div-block-15">
                            <div className="lo-table-info-table-number">Sto {tableInfo.number}<br/><span className="text-span-6">#{selectedTableId}</span> </div>
                            <div className="lo-table-info-table-status">Status: {tableStatusTypeToString(tableInfo.currentStatus)}</div>
                        </div>
                    </div>
                    <div className="lo-table-active-status-div">
                        <div className="admin-settings-box-div lo-table-status">
                            <div className="lo-table-active-orders-bg">
                                <div className="lo-table-active-orders-icon"></div>
                            </div>
                            <div>
                                <div className="text-block-14">Aktivne porudžbine</div>
                                <div className="lo-table-active-orders-number">{tableInfo.orders.filter(order => order.currentStatus !== OrderStatusType.Paid).length}</div>
                            </div>
                        </div>
                        <div className="admin-settings-box-div lo-table-status">
                            <div className="lo-table-active-orders-bg total-amount">
                                <img loading="lazy" src={DollarGreenIcon} alt="" className="icon-size-20" />
                            </div>
                            <div>
                                <div className="text-block-14">Ukupno</div>
                                <div className="lo-table-active-orders-number">{tableInfo.orders.reduce((total, order) => total + order.items.reduce((itemTotal, item) => itemTotal + item.productVariantPrice * item.quantity, 0), 0)} RSD</div>
                            </div>
                        </div>
                    </div>
                    {isCallWaiter && (
                        <div className="lo-table-waiter-call-div">
                            <div>Gost je uputio zahtev za dolazak konobara do stola</div>
                            <div className="small-box-div light-blue-bg pointer" onClick={() => onWaiterReceive?.(selectedTableId || "")}>
                                <div>Označi kao pročitano</div>
                            </div>
                        </div>
                    )}
                    <div className="lo-table-status-block">
                        <div className="lo-table-status-order-div">
                            <div className="lo-table-status-icon ordered"></div>
                            <div>{tableInfo.orders.filter(order => order.currentStatus === OrderStatusType.Ordered).length}</div>
                        </div>
                        <div className="lo-table-status-order-div">
                            <div className="lo-table-status-icon recived"></div>
                            <div>{tableInfo.orders.filter(order => order.currentStatus === OrderStatusType.Recived).length}</div>
                        </div>
                        <div className="lo-table-status-order-div">
                            <div className="lo-table-status-icon served"></div>
                            <div>{tableInfo.orders.filter(order => order.currentStatus === OrderStatusType.Served).length}</div>
                        </div>
                        <div className="lo-table-status-order-div">
                            <div className="lo-table-status-icon bill"></div>
                            <div>{tableInfo.orders.filter(order => order.currentStatus === OrderStatusType.Bill).length}</div>
                        </div>
                        <div className="lo-table-status-order-div">
                            <div className="lo-table-status-icon paid"></div>
                            <div>{tableInfo.orders.filter(order => order.currentStatus === OrderStatusType.Paid).length}</div>
                        </div>
                    </div>
                    <div className="lo-table-orders-block-div">
                        <div className="lo-table-orders-block-header">
                            <div className="text-block-15">Porudžbine</div>
                            <div className="small-box-div grey-bg">
                                <div>{tableInfo.orders.length} Porudžbine</div>
                            </div>
                        </div>
                        <div className="lo-table-orders-list-div">

                            {tableInfo.orders.length === 0 ? (
                                <div className="no-orders-text">Nema porudžbina za ovaj sto.</div>
                            ) : (
                                tableInfo.orders.map(order => (

                                    <OrderInfoView1
                                        key={order.id}
                                        order={order}
                                        handleOrderStatusChange={handleOrderStatusChange}
                                        handleOrderStatusToNext={handleOrderStatusToNext}
                                    />

                                ))
                            )}

                        </div>
                    </div>
                </>
            )}

        </div>
    );

};

export default TableInfoView;